import { useState, useCallback, useMemo } from 'react'

enum InteractionState {
  idle = 'idle',
  fetching = 'fetching',
  error = 'error',
  success = 'success',
}

interface ContractInteraction {
  state: InteractionState
  error: string | null
}

const INIT_STATE: ContractInteraction = {
  state: InteractionState.idle,
  error: null,
}

const FETCHING_STATE: ContractInteraction = {
  state: InteractionState.fetching,
  error: null,
}

const SUCCESS_STATE: ContractInteraction = {
  state: InteractionState.success,
  error: null,
}

const useContractInteraction = () => {
  const [state, changeState] = useState<ContractInteraction>(INIT_STATE)

  const start = useCallback(() => changeState(FETCHING_STATE), [])
  const reset = useCallback(() => changeState(INIT_STATE), [])
  const onError = useCallback((err) => changeState({
    state: InteractionState.error,
    error: err.message ?? err.toString(),
  }), [])
  const onDone = useCallback(() => changeState(SUCCESS_STATE), [])

  return useMemo(() => ({
    state: state.state,
    error: state.error,

    start,
    reset,
    onError,
    onDone,
  }), [state.state, state.error, onError, onDone, reset, start])
}

export default useContractInteraction
